import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-card-sit',
  templateUrl: './card-sit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CardSitComponent {}
